import { useFormContext } from "src/lib/templates";
import { InitialValue } from "../initialValues";

export const useCheckoutFormContext = () => useFormContext<InitialValue>();
